let widgetScriptPromise = null;

export function loadSimplybookWidgetScript() {
	if (widgetScriptPromise) return widgetScriptPromise;

	widgetScriptPromise = new Promise((resolve, reject) => {
		const script = document.createElement("script");
		script.src = "https://simplybook.me/v2/widget/widget.js";
		script.onload = () => resolve();
		script.onerror = () => {
			widgetScriptPromise = null; // allow a retry on the next call
			reject(new Error("Failed to load SimplyBook widget script"));
		};
		document.body.appendChild(script);
	});

	return widgetScriptPromise;
}
